import { useState } from "react";
import { KeyRound } from "lucide-react";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { formatApiError } from "@/context/AuthContext";

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const submit = async () => {
    if (!current || !next) { toast.error("Please fill in all fields"); return; }
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: current, new_password: next });
      toast.success("Password updated successfully");
      reset();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            <KeyRound className="w-5 h-5 text-amber-600" /> Change Password
          </DialogTitle>
          <DialogDescription>Update your account password. Minimum 8 characters.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Current Password</Label>
            <Input type="password" className="mt-1" data-testid="cp-current" value={current} onChange={(e) => setCurrent(e.target.value)} />
          </div>
          <div>
            <Label>New Password</Label>
            <Input type="password" className="mt-1" data-testid="cp-new" value={next} onChange={(e) => setNext(e.target.value)} />
          </div>
          <div>
            <Label>Confirm New Password</Label>
            <Input type="password" className="mt-1" data-testid="cp-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <Button onClick={submit} disabled={saving} className="w-full bg-slate-900 hover:bg-slate-800 text-white" data-testid="cp-submit">
            {saving ? "Updating..." : "Update Password"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
